import { IStyles } from '../../resource';
import palette from '../../theme/palette';

// HubSpot developer embed renders the form inline; HubSpot documents the --hsf-* variables as its styling API
const styles: IStyles = {
  // Reserve space only while HubSpot renders the form, so the short thank-you message is not padded
  formHost: (_theme, { loading }) => ({
    minHeight: loading ? 520 : 0,
    '--hsf-global__font-family': 'Changa, sans-serif',
    // 16px: iOS Safari zooms into inputs with a smaller font when they get focus
    '--hsf-global__font-size': '16px',
    '--hsf-global__color': palette.primary.main,
    '--hsf-global-error__color': '#D32F2F',
    '--hsf-background__background-color': 'transparent',
    '--hsf-background__padding': '0',
    '--hsf-richtext__font-family': 'Changa, sans-serif',
    '--hsf-richtext__font-size': '16px',
    '--hsf-richtext__color': palette.primary.main,
    '--hsf-field-label__font-family': 'Changa, sans-serif',
    '--hsf-field-label__color': palette.primary.main,
    '--hsf-field-label-requiredindicator__color': palette.secondary.main,
    '--hsf-field-input__font-family': 'Changa, sans-serif',
    '--hsf-field-input__color': palette.primary.main,
    '--hsf-field-input__background-color': palette.common.white,
    '--hsf-field-input__border-color': palette.gray.light,
    '--hsf-field-input__border-width': '1px',
    '--hsf-field-input__border-radius': '8px',
    '--hsf-field-input__padding': '10px 12px',
    '--hsf-field-textarea__font-family': 'Changa, sans-serif',
    '--hsf-field-textarea__color': palette.primary.main,
    '--hsf-field-textarea__background-color': palette.common.white,
    '--hsf-field-textarea__border-color': palette.gray.light,
    '--hsf-field-textarea__border-radius': '8px',
    '--hsf-button__font-family': 'Changa, sans-serif',
    '--hsf-button__color': palette.common.white,
    '--hsf-button__background-color': palette.secondary.main,
    '--hsf-button__border-radius': '23px',
    '--hsf-button__padding': '10px 24px',
    '& input:focus, & textarea:focus': {
      outline: 'none',
      borderColor: palette.secondary.main,
    },
    '& input[type=file]::file-selector-button': {
      fontFamily: 'Changa, sans-serif',
      color: palette.secondary.main,
      backgroundColor: palette.common.white,
      border: `1px solid ${palette.secondary.main}`,
      borderRadius: '17px',
      padding: '4px 14px',
      marginRight: '10px',
      cursor: 'pointer',
    },
  }),
};

export default styles;
